import { BonusDataArray, BonusQueryParams, ShareBonusResponse } from '@app/interfaces/bonus';
import { axiosApi } from './axios.api';
import { apiErrorMessage } from './ApiError';

const url = `/api/bonuses`;

export const getBonusApi = async (params?: BonusQueryParams): Promise<BonusDataArray | undefined> => {
  try {
    const response = await axiosApi.get<BonusDataArray>(url, { params });
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export interface BonusEmployeeParams {
  trans_month?: string;
  from_date?: string;
  to_date?: string;
  order_code_cont?: string;
  page?: number;
  per_page?: number;
}

export const getBonusEmployeeApi = async (
  employeeId: string,
  params: BonusEmployeeParams
): Promise<any | undefined> => {
  try {
    const response = await axiosApi.get<any>(`${url}/${employeeId}`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
    return undefined;
  }
};


export const updateBonusApi = async (
  bonusId: string,
  bonusPercent: number
): Promise<{ bonus_percent: number; bonus_amount: number } | undefined> => {
  try {
    const response = await axiosApi.patch(`${url}/${bonusId}`, { bonus_percent: bonusPercent });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
    return undefined;
  }
};

/** Chia đều một dòng thưởng cho thêm nhân viên khác. Lỗi backend (tiếng Việt) được ném ra qua apiErrorMessage. */
export const shareBonusApi = async (bonusId: string, employeeIds: number[]): Promise<ShareBonusResponse> => {
  try {
    const response = await axiosApi.post<ShareBonusResponse>(`${url}/${bonusId}/share`, { employee_ids: employeeIds });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
    throw error;
  }
};

export const exportBonusApi = async (params?: Record<string, any>): Promise<void> => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });
    const objectUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', 'bonus.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
  } catch (error: any) {
    apiErrorMessage(error);
  }
};
